import { InjectionToken } from '@angular/core';
import type {} from '@angular/localize/init';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LOTTERY_BRAND_NAME: InjectionToken<string> = new InjectionToken<string>('LOTTERY_BRAND_NAME', {
  factory: () => $localize`Lottery`
});
